module.exports = __webpack_public_path__ + "img/39.4329b02b.jpg";